import { IComponent } from "./IComponent";
import { PageState } from "../services";
import Plot from "react-plotly.js";
import { MyPlotly } from "./React/MyPlotly";

export class PlotlyComponent implements IComponent {
    element: Element;
    pageState: PageState;
    component: Plot;
    json: any;
    jsonUrl: any;
    open: boolean = false;
    title: string = '';
    width: number = null;
    autoWidth: boolean = true;

    setOpen(value: boolean) {
        this.open = value;
    }

    async attach(element: Element, pageState: PageState, previousState: any) {
        this.element = element;
        this.pageState = pageState;

        this.json = this.element.getAttribute("data-json");
        this.jsonUrl = this.element.getAttribute("data-json-url");
        this.title = this.element.getAttribute("data-title");
        if (this.element.getAttribute("data-width"))
            this.width = parseInt(this.element.getAttribute("data-width"));

        if (this.element.getAttribute("data-auto-width"))
            this.autoWidth = this.element.getAttribute("data-auto-width").toUpperCase() == 'TRUE';

        let response = await fetch(this.jsonUrl);
        let data = await response.json();
        let config = { responsive: true };

        this.component = pageState.reactRender(<div>
            <MyPlotly data={data.data} layout={data.layout} config={config} title={this.title} width={this.width} autoWidth={this.autoWidth} /></div>
            , element, undefined);
        if (previousState) {
            this.component.setState(previousState);
        }
    }
    getState() {
        return this.component.state;
    }
}
